export default "__VITE_ASSET__DucsVi8T__"